export const KEY_CODE = {
  ENTER: 'Enter',
};

export const DEMO_SEARCH_TEXTS = ['Brew', 'VIP', 'Discount'];
